import { CartAddEvent, ThemeEvents } from '@theme/events';

const HANDWRITTEN_NOTE_SELECTOR = '[data-handwritten-note]';
const HANDWRITTEN_NOTE_ALLOWED_CHARS = /[^a-zA-Z0-9 .,!?'"()\-\n]/g;

const initHandwrittenNotes = () => {
    document.querySelectorAll(HANDWRITTEN_NOTE_SELECTOR).forEach((component) => {
      if (component.dataset.noteInit === 'true') return;
      component.dataset.noteInit = 'true';
      const toggleButton = component.querySelector('[data-note-toggle]');
      const formWrapper = component.querySelector('[data-note-form]');
      const cardWrapper = component.querySelector('[data-note-card]');
      const textarea = component.querySelector('[data-note-input]');
      const counter = component.querySelector('[data-note-count]');
      const error = component.querySelector('[data-note-error]');
      const submitButton = component.querySelector('[data-note-submit]');
      const closeButton = component.querySelector('[data-note-close]');
      const form = component.querySelector('form');
      const maxChars = Number(textarea?.getAttribute('maxlength')) || 230;
      const updateCounter = () => {
        if (!textarea || !counter) return;
        counter.textContent = textarea.value.length;
      };
      const sanitizeValue = () => {
        if (!textarea) return;
        const sanitized = textarea.value.replace(HANDWRITTEN_NOTE_ALLOWED_CHARS, '');
        if (sanitized !== textarea.value) {
          textarea.value = sanitized;
        }
        if (textarea.value.length > maxChars) {
          textarea.value = textarea.value.slice(0, maxChars);
        }
        updateCounter();
      };
      const setErrorState = (message) => {
        if (!error) return;
        if (message) {
          error.textContent = message;
          error.hidden = false;
        } else {
          error.hidden = true;
        }
      };
      const showForm = () => {
        formWrapper?.removeAttribute('hidden');
        component.classList.add('handwritten-note-block--open');
        toggleButton?.setAttribute('aria-expanded', 'true');
        cardWrapper?.setAttribute('hidden', 'true');
        textarea?.focus();
      };
      const hideForm = () => {
        formWrapper?.setAttribute('hidden', 'true');
        component.classList.remove('handwritten-note-block--open');
        toggleButton?.setAttribute('aria-expanded', 'false');
        cardWrapper?.removeAttribute('hidden');
        toggleButton?.focus();
      };
      toggleButton?.addEventListener('click', () => {
        if (formWrapper?.hasAttribute('hidden')) {
          showForm();
        }
      });
      closeButton?.addEventListener('click', hideForm);
      textarea?.addEventListener('input', () => {
        sanitizeValue();
        setErrorState('');
      });
      const setSubmitting = (state) => {
        if (!submitButton) return;
        if (state) {
          submitButton.setAttribute('disabled', 'true');
          submitButton.setAttribute('aria-busy', 'true');
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-busy');
        }
      };
      form?.addEventListener('submit', (event) => {
        if (!textarea) return;
        sanitizeValue();
        const value = textarea.value.trim();
        if (!value.length) {
          event.preventDefault();
          setErrorState('Please type a note before adding.');
          textarea.focus();
          return;
        }
        setErrorState('');
        textarea.value = value;
        setSubmitting(true);
      });
      const handleCartResponse = () => setSubmitting(false);
      document.addEventListener(ThemeEvents.cartUpdate, handleCartResponse);
      document.addEventListener(ThemeEvents.cartError, handleCartResponse);
      updateCounter();
    });
  };
  const scheduleHandwrittenNoteInit = () => {
    window.requestAnimationFrame(initHandwrittenNotes);
  };
  document.addEventListener('DOMContentLoaded', scheduleHandwrittenNoteInit);
  document.addEventListener('shopify:section:load', scheduleHandwrittenNoteInit);
  document.addEventListener(ThemeEvents.cartUpdate, scheduleHandwrittenNoteInit);